// Helpers de presentacion del Dashboard de Evaluaciones (sin logica de negocio).

// Color de la "media" / nota por tramos (% de aciertos). Verde / ambar / rojo.
export function scoreColor(score) {
  const s = Number(score) || 0;
  if (s >= 70) return "#00a75a"; // verde marca
  if (s >= 50) return "#e8a33d"; // ambar
  return "#e0524d"; // rojo
}

// Segundos -> "m:ss"
export function formatTime(seconds) {
  const s = Math.max(0, Math.round(Number(seconds) || 0));
  const m = Math.floor(s / 60);
  const rest = String(s % 60).padStart(2, "0");
  return `${m}:${rest}`;
}

// Fecha ISO -> "12 jun" (es)
export function formatShortDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
    });
  } catch {
    return "—";
  }
}

// Iniciales de un nombre para el avatar de fallback.
export function initials(name = "", surname = "") {
  const a = (name || "").trim().charAt(0);
  const b = (surname || "").trim().charAt(0);
  return `${a}${b}`.toUpperCase() || "?";
}
